'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "index", "message", "onToolCall", "part", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SourceDocumentPart = /*#__PURE__*/React.forwardRef(function SourceDocumentPart(props, ref) {
  const {
      className,
      index,
      message,
      onToolCall,
      part,
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  void index;
  void onToolCall;
  const ownerState = React.useMemo(() => ({
    messageId: message.id,
    role: message.role
  }), [message.id, message.role]);
  const Root = slots?.root ?? 'div';
  const Title = slots?.title ?? 'div';
  const Excerpt = slots?.excerpt ?? 'div';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref,
      className
    }
  });
  const titleProps = useSlotProps({
    elementType: Title,
    externalSlotProps: slotProps?.title,
    ownerState
  });
  const excerptProps = useSlotProps({
    elementType: Excerpt,
    externalSlotProps: slotProps?.excerpt,
    ownerState
  });
  return /*#__PURE__*/_jsxs(Root, _extends({}, rootProps, {
    children: [part.title ? /*#__PURE__*/_jsx(Title, _extends({}, titleProps, {
      children: part.title
    })) : null, part.text ? /*#__PURE__*/_jsx(Excerpt, _extends({}, excerptProps, {
      children: part.text
    })) : null]
  }));
});
if (process.env.NODE_ENV !== "production") SourceDocumentPart.displayName = "SourceDocumentPart";
export function createSourceDocumentPartRenderer(defaultProps = {}) {
  return function SourceDocumentPartRendererFn(rendererProps) {
    return /*#__PURE__*/_jsx(SourceDocumentPart, _extends({}, defaultProps, rendererProps));
  };
}